import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
@Component({
  selector: 'link-mutliselect',
  templateUrl: './link-mutliselect.component.html',
  styleUrls: ['./link-mutliselect.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => LinkMutliselectComponent),
    }
  ],
})
export class LinkMutliselectComponent implements OnInit, OnChanges, ControlValueAccessor  {
  _data: any[] = [];
  readOnlyList: any[] = [];
  private parentData: any[] = []
  @Input() data: any[];
  @Output() dataChange = new EventEmitter<any[]>();
  @Input() options: any[];
  @Input() viewMode: boolean;
  @Input() optionLabel?: string = "Name";
  @Input() optionKey?: string = "Key";
  @Input() isDeleted?: string = "IsDeleted";
  @Input() dataKey: string;
  @Input() virtualScroll?: boolean = true;
  @Input() filter?: boolean = true;
  @Input() selectionNumber?: number;
  @Input() displaySelectedLabel?: boolean = true;
  @Input() defaultLabel: string;
  @Output() onRowSelect: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit() {
    ///////////for view mode /////////////////

    //if (this.viewMode) {
    //  for (var i = 0; i < this.data.length; i++) {
    //    let item = this.options.filter(a => a[this.optionKey] == this.data[i][this.dataKey]);
    //    if (item.length > 0)
    //      this.readOnlyList.push(item[0]);
    //  }

    //}
  }
  ngOnChanges(changes: SimpleChanges) {
    // only run when property "data" changed
    if (changes['data'] || changes['dataKey'] || changes['optionKey'] || changes['isDeleted']) {
      this._data = [];
      this.saveItems();
    }
  }
  onChangeHandler($event): void {
    let updatedData = $event;
    //mark deleted items as deleted
    for (var i = 0; i < this.parentData.length; i++) {
      if (!this.parentData[i][this.isDeleted]) {
        let item = updatedData.filter(x => x[this.optionKey] == this.parentData[i][this.dataKey]);
        if (item.length == 0)
          this.parentData[i][this.isDeleted] = true;
      }
    }
    //add new items
    let newItems = updatedData.filter(x => {
      var item = this.parentData.filter(y => y[this.dataKey] == x[this.optionKey] && !y[this.isDeleted])
      return item.length == 0;
    })
    for (var i = 0; i < newItems.length; i++) {
      let item = {};
      item[this.dataKey] = newItems[i][this.optionKey];
      this.parentData.push(item);
    }

    this.dataChange.emit(this.parentData);
    if (this.onModelChange)
      this.onModelChange(this.parentData);
  }
  saveItems() {
    if (this.data && this.dataKey && this.optionKey && this.isDeleted) {
      this.parentData = this.data;
      for (var i = 0; i < this.data.length; i++) {
        if (!this.data[i][this.isDeleted]) {
          let item = {}
          item[this.optionKey] = this.data[i][this.dataKey];
          this._data.push(item)
        }
      }
    }
    else {
      this.parentData = []
    }
    if (this.onModelChange)
      this.onModelChange(this.parentData);
  }
  //////////////////////////////Reactive forms////////////////////////////////////
  onModelChange: Function = () => { };
  onModelTouched: Function = () => { };
  writeValue(obj: any): void {
    if (!obj)
      this.data = [];
    else {
      this.data = obj;
      this.saveItems();
    }
  }
  registerOnChange(fn: any): void {
    this.onModelChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onModelTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
  }
  //////////////////////////////Reactive forms ends////////////////////////////////////
}
